export var FilterType;
(function (FilterType) {
    FilterType["LIST"] = "list";
    FilterType["KEY_VALUE"] = "key_value";
    FilterType["DATE_RANGE"] = "date_range";
    FilterType["THRESHOLD"] = "threshold";
    FilterType["TEXT"] = "text";
})(FilterType || (FilterType = {}));
